export default __webpack_public_path__ + "static/media/035-bullet.cc2e0e47.png";